@if (isDefinded()) {
<div
  class="middlecards"
  [formGroup]="form()">
  <mat-card class="item assignments">
    <mat-card-header>
      <mat-card-title class="title">ASSIGNMENTS</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="titleText">
        <mat-form-field class="full-width">
          <mat-label>Recommendation Title</mat-label>
          <textarea
            formControlName="title"
            matInput></textarea>
          <mat-error>Please define a title</mat-error>
        </mat-form-field>
      </div>
      <div class="middlecards">
        <mat-form-field class="seq">
          <mat-label>Rec. No.</mat-label>
          <input
            id="sequenceNumber1"
            formControlName="sequenceNumber1"
            matInput />
          <mat-error> Rec. No. is required and must be a number </mat-error>
        </mat-form-field>
        <mat-form-field class="seq">
          <mat-label>Rec. No. 2</mat-label>
          <input
            formControlName="sequenceNumber2"
            matInput />
          <mat-error> Rec. No. 2 is required and must be a number </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Priority</mat-label>
          <mat-select formControlName="priority">
            @for (priority of priorities; track priority) {
            <mat-option [value]="priority">{{ priority }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        @if (!isNew()) {
        <div id="legally-required-label">Legally Required:</div>
        <mat-radio-group
          class="radio"
          formControlName="isLegallyRequired"
          aria-labelledby="legally-required-label">
          <mat-radio-button
            name="legallyRequired"
            value="no"
            [checked]="radioButton()"
            >no</mat-radio-button
          >
          <mat-radio-button
            value="yes"
            name="legallyRequired"
            [checked]="!radioButton()"
            >yes</mat-radio-button
          >
        </mat-radio-group>
        }
        <span class="middlecards">
          <mat-form-field>
            <mat-label>Budget in CHF</mat-label>
            <input
              formControlName="budget"
              matInput />
            <mat-error>Field has to be a number</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Category</mat-label>
            <mat-select formControlName="category">
              @for (category of categories; track category) {
              <mat-option value="{{ category }}">{{ category }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <p>Recommendation-ID: {{ recommendations().recommendationId }}</p>
      <div class="middlecards">
        <mat-form-field>
          <mat-label>Initial Deadline set</mat-label>
          <input
            formControlName="initialDeadline"
            matInput
            [matDatepicker]="dateJoined" />
          <mat-datepicker-toggle
            matSuffix
            [for]="dateJoined"></mat-datepicker-toggle>
          <mat-datepicker #dateJoined></mat-datepicker>
          <mat-error>Deadline is required</mat-error>
        </mat-form-field>
        @if (!isNew()) {
        <mat-form-field>
          <mat-label>Prolong</mat-label>
          <input
            formControlName="prolongationDeadline"
            matInput
            [matDatepicker]="dateProlong" />
          <mat-datepicker-toggle
            matSuffix
            [for]="dateProlong"></mat-datepicker-toggle>
          <mat-datepicker #dateProlong></mat-datepicker>
        </mat-form-field>
        } @if (!isNew()) {
        <mat-form-field>
          <mat-label>Other Prolongations</mat-label>
          <input
            [value]="recommendations().other_prolongations || '' | date : 'dd.MM.yyyy'"
            matInput
            disabled />
        </mat-form-field>
        }
      </div>

      <p>Auditor's Recommendation Details</p>
      <div class="middlecards">
        <app-editor
          [form]="form()"
          controlName="shortRemarkToAssessor" />
      </div>
      <p>Plant comments</p>
      <div class="middlecards">
        <app-editor
          [form]="form()"
          controlName="plantComments"
          [disabled]="true" />
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="item management">
    <mat-card-header>
      <mat-card-title class="title">STATUS MANAGEMENT</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-card>
        <mat-card-header>
          <mat-card-title>Status</mat-card-title>
        </mat-card-header>
        <mat-card-content>{{ form().get('status')?.value }}</mat-card-content>
      </mat-card>
      @if (auditorEditable()) {
      <span>
        <div class="adjourne">
          <div id="adjourned-label">Change status to adjourned:</div>
          <mat-radio-group
            formControlName="status"
            (change)="adjournedChange()"
            aria-labelledby="adjourned-label">
            <mat-radio-button value="Adjourned">Adjourned</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <mat-form-field class="full-width">
            <mat-label>Adjourned reason</mat-label>
            <textarea
              matInput
              formControlName="adjournedReason"></textarea>
          </mat-form-field>
        </div>
      </span>
      } @if (auditorEditable()) {
      <div>
        @if (isStatus('Settled') || isStatus('Finally settled') || isStatus('Adjourned')) {
        <button
          mat-raised-button
          class="status-buttons"
          (click)="setNewStatus(State.PENDING)">
          Pending
        </button>
        } @if (isStatus('Pending') || isStatus('Pending & Overdue') || isStatus('Adjourned')) {
        <button
          mat-raised-button
          class="status-buttons"
          (click)="setNewStatus(State.SETTLED)">
          Settled
        </button>
        }
      </div>
      } @if (isStatus('Adjourned') && auditorEditable()) {
      <div class="statusButton">
        <button
          mat-raised-button
          (click)="putBackToPending()">
          Put back to "Pending"
        </button>
      </div>
      } @if (isStatus('Settled') && auditorEditable()) {
      <div class="statusButton">
        <button
          mat-raised-button
          (click)="finallySettleRecommendation()">
          Approval positive - Confirm as "Finally settled"
        </button>
      </div>
      } @if (isStatus('Settled') && auditorEditable()) {
      <div class="statusButton">
        <button
          mat-raised-button
          (click)="putBackToPending()">
          Approval negative - Put back to "Pending"
        </button>
      </div>
      } @if (isStatus('Settled') && auditorEditable()) {
      <div>
        <mat-form-field class="full-width">
          <mat-label>Settle Reject reason</mat-label>
          <textarea
            matInput
            formControlName="settledRejectReason"></textarea>
        </mat-form-field>
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
}
